import React, { useEffect, useState } from "react";
import styles from './LandingPage.module.css';

const Earn = (props) => {

    return (
        <section className={styles.earn}>

            <div className={`${styles.landingContainer} ${styles.earnGrid}`} >

                {/* LEFT IMAGE */}
                <div className={styles.phones2} >
                    <img src="https://admin.rebeltv.me/rebel-homepage-assets/phones2.png" alt="" />
                </div>

                {/* RIGHT CONTENT */}
                <div className={styles.earnList} >

                    <h2>
                        A NEW WAY FOR <br/>
                        <span className={styles.colorText}>CREATORS TO EARN</span>
                    </h2>

                    {/* ITEM 1 */}
                    <div className={styles.earnItem}>
                        <div className={styles.LandingIcon}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/icon-subscription.svg" alt="" />
                        </div>
                        <div className={styles.earnText}>
                            <b>Earn Through Subscriptions</b>
                            <p>Build recurring income from your subscribers.</p>
                        </div>
                    </div>

                    {/* ITEM 2 */}
                    <div className={styles.earnItem}>
                        <div className={styles.LandingIcon}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/icon-tips.svg" alt="" /> 
                        </div>
                        <div className={styles.earnText}>
                            <b>Get Paid by Your Fans</b>
                            <p>Let your audience support you with tips.</p>
                        </div>
                    </div>

                    {/* ITEM 3 */}
                    <div className={styles.earnItem}>
                        <div className={styles.LandingIcon}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/icon-monitize.svg" alt="" />
                        </div>
                        <div className={styles.earnText}>
                            <b>Monetize your Creativity</b>
                            <p>Earn revenue from ad views on content.</p>
                        </div>
                    </div>

                </div>

            </div>

        </section>
    );
};

export default Earn;